'use client';

import clsx from 'clsx';

import { Button } from '@/components/button';

import type { ComponentProps } from 'react';

// Used to have defaults applied to the modal buttons eg classes for spacing
export const ModalButton = ({
  className,
  ...props
}: ComponentProps<typeof Button>) => (
  <Button
    className={clsx('max-lg:grow', className)}
    {...props}
  />
);
